import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import styles from './styles';
import SortButton from 'modules/common/SearchHeaderSortButton';
import classNames from 'classnames';

const SortButtonComponent = ({
  classes,
  className,
  label = 'buttons.sortByDate',
  nameValue = 'asc',
  onClick,
  sortBy,
}) => {
  const { t } = useTranslation('common');
  return (
    <Field
      name={nameValue}
      id="asc"
      ascValue={nameValue}
      sortBy={sortBy}
      onClick={onClick}
      label={t(label)}
      component={SortButton}
      className={classNames(classes.sortButton, className)}
    />
  );
};

SortButtonComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  nameValue: PropTypes.string,
  onClick: PropTypes.func,
  sortBy: PropTypes.string,
};

export default withStyles(styles)(SortButtonComponent);
